import { render, staticRenderFns } from "./ttshop_barter.vue?vue&type=template&id=161cc31e&scoped=true&"
import script from "./ttshop_barter.vue?vue&type=script&lang=js&"
export * from "./ttshop_barter.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_barter.vue?vue&type=style&index=0&id=161cc31e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161cc31e",
  null
  
)

export default component.exports